import React, {memo} from "react";
import {CustomSocket} from "./CustomSocket";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-left: auto;
  position: relative;
`;

const StyledRemoveButtonWrapperDiv = styled.div`
  position: absolute;
  top: -36px;
  right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledTextSlideControlsSocketContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledTextSlideControlsContainerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledHeaderControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
`;

const StyledHeaderControlWrapperDiv = styled.div`
  width: 100%;  
  > div {
    height: ${props => props.$isNodeCollapsed ? "38px" : "100%"}; 
  }
`;

const StyledTextControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-top: 16px;
`;

const StyledTextControlWrapperDiv = styled.div`
  width: 100%;
  > div {
    height: ${props => props.$isNodeCollapsed ? "38px" : "116px"};
  }
`;

const StyledDurationControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-top: 16px;
  > div {
    width: 100%;
  }
`;

const StyledSocketContainerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  width: 0px;
`;

const TextSlide = ({node, controls, output, bindSocket, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    const hasAnswer = SequenceComponentHelper.hasAnswer(node);
    const textSlideUUID = output.key.split("_")[0];
    const removeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextSlideRemoveButtonKey(textSlideUUID)));
    const headerControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextSlideHeaderKey(textSlideUUID)));
    const textControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextSlideTextKey(textSlideUUID)));
    const durationControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextSlideDurationKey(textSlideUUID)));

    return (
        <>

            {/** NESTED NODE - TEXT SLIDE */}
            <StyledNestedNodeDiv>

                {/** REMOVE BTN */}
                {!isNodeCollapsed &&
                    <StyledRemoveButtonContainerDiv>
                        <StyledRemoveButtonWrapperDiv>
                            <Control key={removeControl.key} control={removeControl} innerRef={bindControl}/>
                        </StyledRemoveButtonWrapperDiv>
                    </StyledRemoveButtonContainerDiv>
                }

                {/** TEXT SLIDE CONTROLS & SOCKET */}
                <StyledTextSlideControlsSocketContainerDiv>

                    {/** TEXT SLIDE CONTROLS */}
                    <StyledTextSlideControlsContainerDiv>

                        {/** HEADER CONTROL */}
                        <StyledHeaderControlContainerDiv>
                            <StyledHeaderControlWrapperDiv $isNodeCollapsed={isNodeCollapsed}>
                                <Control key={headerControl.key} control={headerControl} innerRef={bindControl}/>
                            </StyledHeaderControlWrapperDiv>

                        </StyledHeaderControlContainerDiv>

                        {/** TEXT CONTROL */}
                        <StyledTextControlContainerDiv>
                            <StyledTextControlWrapperDiv $isNodeCollapsed={isNodeCollapsed}>
                                <Control key={textControl.key} control={textControl} innerRef={bindControl}/>
                            </StyledTextControlWrapperDiv>
                        </StyledTextControlContainerDiv>

                        {/** DURATION CONTROL */}
                        {!isNodeCollapsed &&
                            <StyledDurationControlContainerDiv>
                                <Control key={durationControl.key} control={durationControl} innerRef={bindControl}/>
                            </StyledDurationControlContainerDiv>
                        }

                    </StyledTextSlideControlsContainerDiv>

                    {/** SOCKET */}
                    <StyledSocketContainerDiv>
                        {output && !hasAnswer &&
                            <CustomSocket type="output" socket={output.socket}
                                          io={output} innerRef={bindSocket}/>
                        }
                    </StyledSocketContainerDiv>
                </StyledTextSlideControlsSocketContainerDiv>
            </StyledNestedNodeDiv>
        </>
    );
}

export default memo(TextSlide);